/**
 * Decides which relation operations move requires.
 * Backend deletes any existing parent relation when a new one is
 * created, so re-parenting only needs an add.
 * Moving to root (without a new parent) needs an explicit delete of the old parent relation.
 */
export function planMoveOperations({
  oldParentDataNodeId,
  newParentDataNodeId
}: {
  oldParentDataNodeId: string | null;
  newParentDataNodeId: string | null;
}): { shouldAdd: boolean; shouldDelete: boolean } {
  if (oldParentDataNodeId === newParentDataNodeId) {
    return { shouldAdd: false, shouldDelete: false };
  }
  if (newParentDataNodeId !== null) {
    return { shouldAdd: true, shouldDelete: false };
  }
  return { shouldAdd: false, shouldDelete: true };
}
